import type { Undefinable } from "@core/domain/types/undefinable.type";

export type KanbanBlockPhase = "" | "planning" | "execution" | "evaluation";

export class ProjectKanbanBlock {
    constructor(
        public readonly id: number,
        public projectId: number,
        public name: string,
        public position: number,
        public phase: KanbanBlockPhase = "",
        public isActive?: Undefinable<boolean>,
    ) {}
}
